import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";

import Loader from "../../common/loader";
import { formateDate, showStatus } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { TempleServiceDetails } from "../../services/temple-service.services";

const ServiceViewTemple = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const [service, setService] = useState(null);

  const breadcrumbs = [
    { title: t("Dashboard"), url: "/admin/dashboard" },
    { title: t("Temple"), url: "/admin/temples/list/1" },
    { title: t("Service"), url: "/admin/temple-service/list/1" },
    { title: t("View"), url: "" },
  ];

  useEffect(() => {
    TempleServiceDetails(params.id)
      .then((res) => {
        setService(res?.data || null);
      })
      .catch((err) => {
        console.log("error ===>", err);
      });
  }, [params.id]);

  if (!service) return <Loader />;

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="main-content-label mb-3">
                {t("View Temple Service")}
              </h6>

              <div className="row">
                <div className="col-lg-12 form-group">
                  <table className="table table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th>{t("Service Name")}</th>
                        <td>{service.name || "N/A"}</td>
                      </tr>

                      <tr>
                        <th>{t("Service Type")}</th>
                        <td>{service.serviceType || "N/A"}</td>
                      </tr>

                      <tr>
                        <th>{t("Duration")}</th>
                        <td>{service.duration ? `${service.duration} Minute` : "N/A"}</td>
                      </tr>

                      <tr>
                        <th>{t("Price")}</th>
                        <td>{service.price != null ? `₹ ${service.price}` : "N/A"}</td>
                      </tr>

                      <tr>
                        <th>{t("Description")}</th>
                        <td>{service.description || "N/A"}</td>
                      </tr>

                      <tr>
                        <th>{t("Status")}</th>
                        <td>{service.status ? toHtml(showStatus(1)) : toHtml(showStatus(0))}</td>
                      </tr>

                      <tr>
                        <th>{t("Created Date")}</th>
                        <td>{service.createdAt ? formateDate(service.createdAt) : "N/A"}</td>
                      </tr>

                      {/* Optional: Temple basic info if populated */}
                      {service.templeId && (
                        <>
                          <tr>
                            <th>{t("Temple Name")}</th>
                            <td>{service.templeId.templeName || "N/A"}</td>
                          </tr>
                          <tr>
                            <th>{t("Temple Location")}</th>
                            <td>{service.templeId.templeLocation || "N/A"}</td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="ml-4 back-button mx-0">
                <button
                  className="btn ripple btn-dark"
                  type="button"
                  onClick={() => navigate("/admin/temple/service/1")}
                >
                  <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                  {t("btn_back")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceViewTemple;
